import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';
import { defineStepper } from '@stepperize/react';
import { z } from 'zod';
import { tariffSchema } from 'widgets/project-creation-stepper/model';
import * as m from '@paraglide/messages';
const createStepper = () => defineStepper({
  id: 'service-type',
  title: m.create_dialog_step_service(),
  description: 'First step',
  schema: z.object({})
}, {
  id: 'tariff',
  title: m.create_dialog_step_tariff(),
  description: 'Second step',
  schema: tariffSchema
}, {
  id: 'upload',
  title: m.create_dialog_step_upload(),
  description: 'Third step',
  schema: z.object({})
}, {
  id: 'variables',
  title: m.create_dialog_step_variables(),
  description: 'Fourth step',
  schema: z.object({})
}, {
  id: 'config',
  title: m.create_dialog_step_config(),
  description: 'Fifth step',
  schema: z.object({})
});
const Stepper = createStepper();
export type IStepper = any;
const StepperContext = createContext(Stepper);
export const useStep = () => useContext(StepperContext);
export function StepperProvider({
  children,
  initialState
}: {
  children: ReactNode;
  initialState?: IStepper;
}) {
  const currentStepper = initialState ?? createStepper();
  return <StepperContext.Provider value={currentStepper} data-sentry-element="unknown" data-sentry-component="StepperProvider" data-sentry-source-file="stepper-provider.tsx">
      {children}
    </StepperContext.Provider>;
}